import { Link } from "react-router";
import { withBuildingScope } from "../ui/building-scope";
export type InspectionOrigin = {
  id: string;
  report_id: string;
  development_id: string;
  purpose: string;
  observation: {
    revision: number;
    label: string;
    answer: {
      value?: string;
      notes?: string;
      photoException?: { reason: string };
    };
    photos: { documentId: string; versionId: string }[];
  };
};
export function InspectionFindingOrigins({
  items = [],
}: {
  items?: InspectionOrigin[] | undefined;
}) {
  if (!items.length) return null;
  return (
    <section aria-label="Original inspection observations">
      <h2>Original inspection observations</h2>
      {items.map((f) => (
        <article key={f.id}>
          <h3>
            {f.observation.label} · {f.purpose}
          </h3>
          <p>
            Submission {f.observation.revision} ·{" "}
            {f.observation.answer.value === "Fail"
              ? "Concern"
              : f.observation.answer.value === "Unable to check"
                ? "Not inspected"
                : (f.observation.answer.value ?? "Photo exception")}
          </p>
          <p>
            {f.observation.answer.notes ??
              f.observation.answer.photoException?.reason}
          </p>
          <p>{f.observation.photos.length} retained photographs</p>
          <Link
            to={withBuildingScope("/reports/" + f.report_id, f.development_id)}
          >
            Open original inspection and photographs
          </Link>
        </article>
      ))}
    </section>
  );
}
